"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorsContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _IE11Flexbug3Fix = require("./IE11Flexbug3Fix");
const IndicatorsContainer = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_IE11Flexbug3Fix.IE11Flexbug3Fix, null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.IndicatorsContainer, props, children));
};
exports.IndicatorsContainer = IndicatorsContainer;
//# sourceMappingURL=IndicatorsContainer.js.map